/**
 * @class directive_v3sLogo
 * @memberOf v3sWbtPlayerApp:navigation:navbar
 * @description
 * Das Logo in der Navigationsleiste
 */
angular.module('v3sWbtPlayerApp').directive('v3sLogo', ['v3sContentPath', 'v3sLogoConfig', function (v3sContentPath, v3sLogoConfig) {
    return {
        restrict: 'E',
        template: '<img ng-src="{{logoUrl}}" class="logo-{{logoPos}} btn" ng-show="showLogo"></img>',
        link: function (scope, element, attrs, docCtrl) {
            var hasUrl = v3sLogoConfig.navLogoUrl && v3sLogoConfig.navLogoUrl != "none";
            scope.showLogo = hasUrl;

            if (hasUrl) {
                scope.logoUrl = v3sContentPath + v3sLogoConfig.navLogoUrl;
                scope.logoPos = v3sLogoConfig.navLogoPosition;
            } else {
                scope.logoUrl = "";
            }


        }
    }
}]);
